<script setup lang="ts">
import type { DateRange } from 'reka-ui'
import { RangeCalendar } from '@/components/ui/range-calendar'
import { getLocalTimeZone, parseDate, today } from '@internationalized/date'
import { type Ref, ref, watch } from 'vue'
import { cn, formatDate } from '@/lib/utils'
import { Button } from '@/components/ui/button'
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover'
import { Calendar as CalendarIcon } from 'lucide-vue-next'
import { getStoredDate } from '@/lib/localStorage'
import { Label } from '@/components/ui/label'

const emit = defineEmits(['change'])
const saved_date = getStoredDate()
const current_year = today(getLocalTimeZone()).year

const start = saved_date
  ? parseDate(
      `${saved_date.start.year}-${String(saved_date.start.month).padStart(2, '0')}-${String(saved_date.start.day).padStart(2, '0')}`,
    )
  : parseDate(`${current_year}-01-01`)
const end = saved_date
  ? parseDate(
      `${saved_date.end.year}-${String(saved_date.end.month).padStart(2, '0')}-${String(saved_date.end.day).padStart(2, '0')}`,
    )
  : parseDate(`${current_year}-12-31`)
const date = ref({ start, end }) as Ref<DateRange>

const handleSelectionChange = (newValue: DateRange) => {
  localStorage.setItem('date_range', JSON.stringify(newValue))
  emit('change')
}

watch(date, () => {
  emit('change')
})
</script>

<template>
  <form class="space-y-8">
    <div class="flex flex-col gap-2">
      <Label>Date</Label>
      <Popover>
        <PopoverTrigger as-child>
          <Button
            variant="outline"
            :class="cn('w-[240px] ps-3 text-start font-normal', !date && 'text-muted-foreground')"
          >
            <span
              >{{ formatDate(date?.start?.toString() ?? '') }} -
              {{ formatDate(date?.end?.toString() ?? '') }}</span
            >
            <CalendarIcon class="ms-auto h-4 w-4 opacity-50" />
          </Button>
          <input hidden />
        </PopoverTrigger>
        <PopoverContent class="w-auto p-0">
          <RangeCalendar
            @update:modelValue="handleSelectionChange"
            v-model="date"
            locale="fr-FR"
            class="rounded-md border"
          />
        </PopoverContent>
      </Popover>
    </div>
  </form>
</template>
